import React from 'react';
import styles from '../styles/AboutUs.module.css';
import Member from '../components/Member';
import WireframeBackground from '../components/WireframeBackground';

function AboutUs() {
    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <div className={styles.header}>
                    <h2 className={styles.sectionTitle}>ABOUT US</h2>
                    <p className={styles.subtitle}>私たちについて</p>
                </div>

                {/* 会社概要セクション */}
                <div id="company-overview" className={styles.section}>
                    <div className={styles.card}>
                        {/* コーナー装飾 */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <ul className={styles.infoList}>
                            <li><strong>社名:</strong><span className={styles.infoValue}>株式会社Parnas（パルナス）</span></li>
                            <li><strong>代表:</strong><span className={styles.infoValue}>山下 貴裕</span></li>
                            <li><strong>事業:</strong><span className={styles.infoValue}>CG映像制作</span></li>
                            <li><strong>設立:</strong><span className={styles.infoValue}>2022年3月</span></li>
                            <li><strong>住所:</strong><span className={styles.infoValue}>東京都港区港南2-17-1 京王品川ビル2F 10号室</span></li>
                        </ul>
                    </div>
                </div>

                {/* 代表挨拶セクション */}
                <div id="ceo-greeting" className={styles.section}>
                    <h3 className={styles.title}>代表挨拶</h3>
                    <div className={styles.ceoCard}>
                        {/* コーナー装飾 */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <div className={styles.ceoContent}>
                            <img src="/images/member/yamashita.png" alt="代表 山下貴裕" className={styles.ceoImage} />
                            <div className={styles.ceoText}>
                                <div className={styles.ceoGreeting}>MISSION: ANIMATING ASSETS</div>
                                <p>
                                    私たちはリギングに特化した先進サービスを展開しています。<br /><br />
                                    最も人材育成が難しいリギング領域で、日本全国のクリエイターが活躍できる機会を創るためフルリモートで。
                                    こうしてParnasは生まれました。<br /><br />
                                    日本のCGコンテンツを心待ちにする世界中の人々に感動を届けられるよう、チーム一丸となって技術を磨きます。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* メンバー紹介セクション */}
                <div id="member-intro" className={styles.section}>
                    <Member />
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
